<span [class.highlight]="menuEl.menuOpen" *ngIf="showTitle" class="title">{{ 'dashboard:Select Time Period' | i18next }}</span>
<div class="main-container">
    <i class="fad fa-chevron-circle-left nav-button" (click)="decrease()" [matTooltip]="'Previous' | i18next" matTooltipClass="tooltip-font-14" [class.disabled]="selectedRange==rangeType.custom"></i>
    <div class="date-text" [class.underline]="menuEl.menuOpen" [matMenuTriggerFor]="menu" #menuEl="matMenuTrigger" (menuClosed)="SetDates()" [matTooltip]="'dashboard:Click to change time unit or set a custom time period' | i18next" matTooltipClass="tooltip-font-14">
        <div>
            <ng-container *ngIf="selectedRange!=rangeType.custom"> {{selectedText()}}</ng-container>
            <ng-container *ngIf="selectedRange==rangeType.custom"> {{this.selectedFrom?.format('L')}} {{this.selectedFromTime}} - {{this.selectedTo?.format('L')}} {{this.selectedToTime}}</ng-container>
        </div>
        <div><i class="fal fa-calendar-alt"></i></div>
    </div>
    <i class="fad fa-chevron-circle-right nav-button" (click)="increase()" [matTooltip]="'Next' | i18next" matTooltipClass="tooltip-font-14" [class.disabled]="selectedRange==rangeType.custom"></i>
    </div>
<mat-menu #menu="matMenu" class="large-menu">
    <div class="container" [class.container-custom]="selectedRange==rangeType.custom">
        <div>
            <div class="container-header">
                {{ 'dashboard:Select Time Period' | i18next }}
            </div>
            <button mat-menu-item (click)="selectType($event,rangeType.day)"  [class.selected]="selectedRange==rangeType.day && value==-1" class="data-picker-menu-item">
                <span>{{ 'dashboard:Yesterday' | i18next }}</span>
            </button>
            <button mat-menu-item (click)="selectType($event,rangeType.week)" [class.selected]="selectedRange==rangeType.week && value==-1"  class="data-picker-menu-item">
                <span>{{ 'dashboard:Last week' | i18next }}</span>
            </button>
            <button mat-menu-item (click)="selectType($event,rangeType.month)" [class.selected]="selectedRange==rangeType.month && value==-1" class="data-picker-menu-item">
                <span>{{ 'dashboard:Last month' | i18next }}</span>
            </button>
            <button mat-menu-item [class.selected]="selectedRange==rangeType.custom" class="data-picker-menu-item"
                (click)="selectType($event,rangeType.custom)">
                <span>{{ 'dashboard:Custom' | i18next }}</span>
            </button>
        </div>
        <div class="calendars-wrapper" *ngIf="selectedRange==rangeType.custom"
                (click)="$event.stopPropagation();" (keydown.tab)="$event.stopPropagation()" (keydown.shift.tab)="$event.stopPropagation()">
            <div class="time">
                <div class="time-select">
                   {{selectedFrom.format("LL")}} <input type="text" [(ngModel)]="selectedFromTime" (setTime)="selectedFromTime=$event" reports-time/>
                </div>
                <div>{{ 'dashboard:to' | i18next }}</div>
                <div class="time-select">
                    {{selectedTo.format("LL")}} <input type="text" [(ngModel)]="selectedToTime" (setTime)="selectedToTime=$event" reports-time/>
                </div>
            </div>
            <div class="calendars">
                <div>
                    <mat-calendar [(selected)]="selectedFrom" [minDate]="firstDate" [maxDate]="maxFromDate"
                        [startAt]="selectedFrom" [activeDate]="selectedFrom"
                        (selectedChange)="CalcMaxToDate(calendarTo)"></mat-calendar>
                </div>
                <div>
                    <mat-calendar [(selected)]="selectedTo" [minDate]="selectedFrom" [maxDate]="maxToDate"
                        [startAt]="selectedTo" [activeDate]="selectedFrom" #calendarTo></mat-calendar>
                </div>
            </div>
            <div class="calendars-buttons">
                <button mat-flat-button color="accent" (click)="menuEl.closeMenu()">{{ 'dashboard:Set' | i18next }}</button>
            </div>
        </div>
    </div>
</mat-menu>
